import styled from 'styled-components';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
function Sliders({ work, index }) {
  return (
    <Wrap>
      {index === 0 && (
        <Carousel
          showStatus={false}
          infiniteLoop={true}
          autoPlay={true}
          interval={8000}
          stopOnHover={false}
          showArrows={false}
          swipeable={false}
        >
          <SlideItem>
            <h3>{work[0].work.work1.title}</h3>
            <p>
              {work[0].work.work1.text}
              <br />
            </p>
          </SlideItem>
          <SlideItem>
            <h3>{work[0].work.work2.title}</h3>
            <p>
              {work[0].work.work2.text}
              <br />
            </p>
          </SlideItem>
        </Carousel>
      )}
      {index === 1 && (
        <Carousel
          showStatus={false}
          infiniteLoop={true}
          autoPlay={true}
          interval={8000}
          stopOnHover={false}
          showArrows={false}
          swipeable={false}
        >
          <SlideItem>
            <h3>{work[1].work.work1.title}</h3>
            <p>
              {work[1].work.work1.text}
              <br />
            </p>
          </SlideItem>
          <SlideItem>
            <h3>{work[1].work.work2.title}</h3>
            <p>
              {work[1].work.work2.text}
              <br />
            </p>
          </SlideItem>
          <SlideItem>
            <h3>{work[1].work.work3.title}</h3>
            <p>
              {work[1].work.work3.text}
              <br />
            </p>
          </SlideItem>
        </Carousel>
      )}
      {index === 2 && (
        <Carousel
          showStatus={false}
          infiniteLoop={true}
          autoPlay={true}
          interval={8000}
          stopOnHover={false}
          showArrows={false}
          swipeable={false}
        >
          <SlideItem>
            <h3>{work[2].work.work1.title}</h3>
            <p>
              {work[2].work.work1.text}
              <br />
            </p>
          </SlideItem>
          <SlideItem>
            <h3>{work[2].work.work2.title}</h3>
            <p>
              {work[2].work.work2.text}
              <br />
            </p>
          </SlideItem>
        </Carousel>
      )}
      {index === 3 && (
        <Carousel
          showStatus={false}
          infiniteLoop={true}
          autoPlay={true}
          interval={8000}
          stopOnHover={false}
          showArrows={false}
          swipeable={false}
        >
          <SlideItem>
            <h3>{work[3].work.work1.title}</h3>
            <p>
              {work[3].work.work1.text}
              <br />
            </p>
          </SlideItem>
          <SlideItem>
            <h3>{work[3].work.work2.title}</h3>
            <p>
              {work[3].work.work2.text}
              <br />
            </p>
          </SlideItem>
        </Carousel>
      )}
    </Wrap>
  );
}
const SlideItem = styled.div`
  color: #fff;
  text-align: left;
  padding: 20px;
  width: 100%;
  margin: 120px 0;
  h3 {
    font-size: 25px;
    font-weight: bold;
  }
  p {
    margin-top: 30px;
    text-align: left;
    font-size: 20px;
    line-height: 35px;
  }
  @media only screen and (max-width: 992px) {
    margin: 50px 0;
    padding: 10px 0;
    p {
      margin-top: 30px;
      line-height: 30px;
    }
  }
  @media only screen and (max-width: 750px) {
    margin: 30px 0;
    padding: 5px 0;
    h3 {
      font-size: 18px;
    }
    p {
      margin-top: 20px;
      font-size: 16px;
      line-height: 25px;
    }
  }
`;

const Wrap = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export default Sliders;
